<div class="overview-container">
  @if (pkg(); as activePackage) {
    <cyborg-hunt-package-overview
      [data]="activePackage"
    ></cyborg-hunt-package-overview>
  }
</div>
